module.exports = __webpack_public_path__ + "5cb4b2a03a86b1872deca6ea58afe87f.ttf";